import { Action } from '@ngrx/store';
import { FollowsRetroplannings } from '@app/models/retroplanning';

export enum RetroplanningActionTypes {
  Load = '[Retroplanning] Load retroplannings',
  LoadSuccess = '[Retroplanning] Load retroplanning success',
  LoadFail = '[Retroplanning] Load retroplanning fail',
  LoadSingle = '[Retroplanning] Load single retroplanning',
  LoadSingleSuccess = '[Retroplanning] Load single retroplanning Success',
  LoadSingleFail = '[Retroplanning] Load single retroplanning Fail',
  AddOne = '[Retroplanning] Add one',
  AddAll = '[Retroplanning] Add all',
  Create = '[API] Create retroplanning',
  CreateSuccess = '[API] Create retroplanning success',
  CreateFail = '[API] Create retroplanning fail',

  Update = '[API] Update consigneer',
  UpdateSuccess = '[API] Update retroplanning success',
  UpdateFail = '[API] Update retroplanning fail',
  UpdateOne = '[Retroplanning] Update one',
  ExportRetroplanning = '[Retroplanning] Export retroplanning',
  ExportRetroplanningSuccess = '[Retroplanning] Export retroplanning success',
  ExportRetroplanningFail = '[Retroplanning] Export retroplanning fail',

  GetRetroplanningsLink = '[Retroplanning] Get retroplanning link',
  GetRetroplanningsLinkSuccess = '[Retroplanning] Get retroplanning link success',
  GetRetroplanningsLinkFail = '[Retroplanning] Get retroplanning link fail',

  UploadRetroplanning = '[Retroplanning] Upload file retroplanning',
  UploadRetroplanningSucces = '[Retroplanning] Upload file retroplanning success',
  UploadRetroplanningFail = '[Retroplanning] Upload file retroplanning fail',

  UploadProcessUpdate = '[Retroplanning] upload file process update',
  UploadProcessSuccess = '[Retroplanning] upload file process success',
  UploadProcessFail = '[Retroplanning] upload file process fail',

  DeleteRetroplanning = '[Retroplanning] Retroplanning delete',
  DeleteRetroplanningSuccess = '[Retroplanning] Retroplanning delete success'
}

export class Load implements Action {
  readonly type = RetroplanningActionTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = RetroplanningActionTypes.LoadSuccess;
  // constructor(public data: Retroplanning[]) {}
  constructor(public data: any) {}
}

export class LoadFail implements Action {
  readonly type = RetroplanningActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class LoadSingle implements Action {
  readonly type = RetroplanningActionTypes.LoadSingle;
  constructor(public id: number) {}
}

export class LoadSingleSuccess implements Action {
  readonly type = RetroplanningActionTypes.LoadSingleSuccess;
  constructor(public data: any) {}
}

export class LoadSingleFail implements Action {
  readonly type = RetroplanningActionTypes.LoadSingleFail;
  constructor(public error: any) {}
}

export class AddOne implements Action {
  readonly type = RetroplanningActionTypes.AddOne;
  constructor(public retroplanning: any) {}
}

export class AddAll implements Action {
  readonly type = RetroplanningActionTypes.AddAll;
  constructor(public retroplanning: any) {}
}

export class Create implements Action {
  readonly type = RetroplanningActionTypes.Create;
  constructor(
    public followId: number,
    public retroplanning: FollowsRetroplannings
  ) {}
}

export class CreateSuccess implements Action {
  readonly type = RetroplanningActionTypes.CreateSuccess;
  constructor(public retroplanning: FollowsRetroplannings) {}
}

export class CreateFail implements Action {
  readonly type = RetroplanningActionTypes.CreateFail;
  constructor(public error: any) {}
}

export class Update implements Action {
  readonly type = RetroplanningActionTypes.Update;
  constructor(public followId: number, public data: any) {}
}

export class UpdateSuccess implements Action {
  readonly type = RetroplanningActionTypes.UpdateSuccess;
  constructor(public retroplanningId: number, public data: any) {}
}

export class UpdateFail implements Action {
  readonly type = RetroplanningActionTypes.UpdateFail;
  constructor(public error: any) {}
}

export class UpdateOne implements Action {
  readonly type = RetroplanningActionTypes.UpdateOne;
  constructor(public retroplanning: FollowsRetroplannings) {}
}

export class ExportRetroplanning implements Action {
  readonly type = RetroplanningActionTypes.ExportRetroplanning;
  constructor(
    public id: number,
    public name: string,
    public exportType: string
  ) {}
}

export class ExportRetroplanningSuccess implements Action {
  readonly type = RetroplanningActionTypes.ExportRetroplanningSuccess;
  constructor() {}
}

export class ExportRetroplanningFail implements Action {
  readonly type = RetroplanningActionTypes.ExportRetroplanningFail;
  constructor() {}
}

export class GetRetroplanningsLink implements Action {
  readonly type = RetroplanningActionTypes.GetRetroplanningsLink;
  constructor(public file: any, public followId?: number) {}
}

export class GetRetroplanningsLinkSuccess implements Action {
  readonly type = RetroplanningActionTypes.GetRetroplanningsLinkSuccess;
  constructor(public data: any) {}
}

export class GetRetroplanningsLinkFail implements Action {
  readonly type = RetroplanningActionTypes.GetRetroplanningsLinkFail;
  constructor(public error: any) {}
}

export class UploadRetroplanning implements Action {
  readonly type = RetroplanningActionTypes.UploadRetroplanning;
  constructor(
    public uploadUrl: string,
    public FileId: number,
    public file: any
  ) {}
}

export class UploadRetroplanningSucces implements Action {
  readonly type = RetroplanningActionTypes.UploadRetroplanningSucces;
  constructor(public FileId: number) {}
}

export class UploadRetroplanningFail implements Action {
  readonly type = RetroplanningActionTypes.UploadRetroplanningFail;
  constructor(public error: any) {}
}

export class UploadProcessUpdate implements Action {
  readonly type = RetroplanningActionTypes.UploadProcessUpdate;
  constructor(public data: any) {}
}

export class UploadProcessSuccess implements Action {
  readonly type = RetroplanningActionTypes.UploadProcessSuccess;
  constructor(public data: any) {}
}

export class UploadProcessFail implements Action {
  readonly type = RetroplanningActionTypes.UploadProcessFail;
  constructor(public error: any) {}
}

export class DeleteRetroplanning implements Action {
  readonly type = RetroplanningActionTypes.DeleteRetroplanning;
  constructor(public idRetroplaning: number, public followId: number) {}
}

export class DeleteRetroplanningSuccess implements Action {
  readonly type = RetroplanningActionTypes.DeleteRetroplanningSuccess;
  constructor(public followId: any) {}
}

export type RetroplanningActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | LoadSingle
  | LoadSingleSuccess
  | LoadSingleFail
  | AddOne
  | AddAll
  | Create
  | CreateSuccess
  | CreateFail
  | Update
  | UpdateSuccess
  | UpdateFail
  | UpdateOne
  | ExportRetroplanning
  | ExportRetroplanningSuccess
  | ExportRetroplanningFail
  | GetRetroplanningsLink
  | GetRetroplanningsLinkSuccess
  | GetRetroplanningsLinkFail
  | UploadRetroplanning
  | UploadRetroplanningSucces
  | UploadRetroplanningFail
  | UploadProcessUpdate
  | UploadProcessSuccess
  | UploadProcessFail
  | DeleteRetroplanning
  | DeleteRetroplanningSuccess;
